// @flow weak

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as viewsActions from "../../redux/reducers/views";
import Login from "./Login";
import { userActions } from "../../redux/actions/user";

const mapStateToProps = state => {
  return {
    currentView: state.views.currentView,
    user: state.user.user,
    messages: state.user.messages
  };
};

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/app/views/login/index.js